import { render, staticRenderFns } from "./ScalePlugin.vue?vue&type=template&id=3321838e&scoped=true"
import script from "./ScalePlugin.vue?vue&type=script&lang=ts"
export * from "./ScalePlugin.vue?vue&type=script&lang=ts"
import style0 from "./ScalePlugin.vue?vue&type=style&index=0&id=3321838e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3321838e",
  null
  
)

export default component.exports